import apiRequest from "../../services/apiRequest";

export default {
  namespaced: true,
  state: {
    webinars: [],
    recommendedWebinars: []
  },
  mutations: {
    setWebinars(state, webinars) {
      webinars.sort((a, b) => (a.date < b.date ? 1 : -1));
      state.webinars = webinars;
    },
    setRecWebinars(state, recWeb) {
      state.recommendedWebinars = recWeb;
    }
  },
  actions: {
    getWebinars({ commit, rootGetters }, symbol) {
      commit("incrementPendingApiCallsCount", null, { root: true });
      let serviceUrl = rootGetters.baseNewApiUrl + "/webinars";
      if (symbol) serviceUrl = `${serviceUrl}/symbol/${symbol}`;
      return apiRequest.get(serviceUrl).then(function(json) {
        commit("setWebinars", json);
        commit("decrementPendingApiCallsCount", null, { root: true });
      });
    },
    async getRecommendedWebinars({ commit, rootGetters }) {
      commit("incrementPendingApiCallsCount", null, { root: true });
      return apiRequest
        .get(rootGetters.baseNewApiUrl + "/webinars/recommended")
        .then(function(json) {
          commit("setRecWebinars", json);
          commit("decrementPendingApiCallsCount", null, { root: true });
        });
    }
  }
};
